import * as _ from 'lodash';
import { diagnostics, utils } from '@blend/ui-common';
import { AcceptedTermsTypes, softCreditConsentTypes } from 'login-components/Common/Inputs/RequirementInput/utils';
import * as loanUtils from 'login-utils/loanUtils';
import * as onboardingForm from 'login-utils/onboardingForm';
import * as userUtils from 'login-utils/userUtils';
import baseRequest from './baseRequest';

const { featureFlags } = utils;

export interface JourneyChooserEntryInfo {
  requiredConsents: AcceptedTermsTypes[];
  softCreditConsentSupportedValues: onboardingForm.TimelineValue[];
  loanType: LoanType;
  journeyOptionIsLocked: boolean;
  showTimelineConfigs: boolean;
  showChosenLoanType: boolean;
  journeyOption?: onboardingForm.TimelineValue;
  phoneNumber?: string;
}

export async function getJourneyChooserInfo(loanId: string): Promise<JourneyChooserEntryInfo> {
  return (await baseRequest.get(`/api/login-ui/loans/${loanId}/journey-chooser`)).data;
}

export async function journeyChooserSubmit(values, loanId: string, consents: AcceptedTermsTypes[]) {
  const formValues: { [key: string]: any } = _.pick(
    values,
    'phoneNumber',
    'propertySearchType',
    'loanPurpose',
    'giveConsentToLenderContact',
  );

  // a double check on whether or not the user has actually checked the box to confirm they consent to the consents
  // specified in the journey chooser. If the feature flag is on, there is no box to check or redux value to update;
  // we assume that the component has disabled submit until the terms have been viewed
  const userGaveConsent =
    !!values.acceptTermsAndConditions || featureFlags.isEnabled('requireViewingTermsBeforeAccepting20190904');

  let modelProperties = {
    homePhone: formValues.phoneNumber,
    consentToLenderContactGiven: formValues.giveConsentToLenderContact,
    propertySearchType: formValues.propertySearchType,
    loanPurpose: formValues.loanPurpose,
    econsentGiven: userGaveConsent && _.includes(consents, 'eConsent'),
    softCreditConsentGiven:
      userGaveConsent && _.some(softCreditConsentTypes, consentType => _.includes(consents, consentType)),
  };

  // propertySearchType may be null if loanPurpose is REFINANCE; don't send it to the api if so
  if (modelProperties.propertySearchType === null) {
    modelProperties = _.omit(modelProperties, 'propertySearchType');
  }

  const currentUser = userUtils.getCurrentUser();
  diagnostics.breadcrumb('submitting journey chooser', {
    loanId: loanUtils.getSelectedProductId(),
    userId: _.get(currentUser, '_id', 'none'),
    loginMethod: _.get(currentUser, 'loginMethod', 'none'),
  });
  return await baseRequest.post(`/api/login-ui/loans/${loanId}/journey-chooser`, {
    modelProperties,
    acceptTerms: userGaveConsent && _.includes(consents, 'termsOfUse'),
  });
}
